import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { UserRequestModel, UserViewModel } from './../business-entities/user-view-model';

@Injectable({
  providedIn: 'root'
})
export class ReceptionDataService {

  constructor(private dataProvider: DataService) { }

  addUpdateUser(userDetails: UserViewModel): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddUpdateUser, userDetails).toPromise();
  }

  getUserList(userRequestModel:UserRequestModel):Promise<GenericResponse<Array<UserViewModel>>> 
  {
      return this.dataProvider.Post<GenericResponse<Array<UserViewModel>>>(Urls.GetUserList,userRequestModel).toPromise();
  }

  async getUserDetail(id: string): Promise<GenericResponse<UserViewModel>> {
    return this.dataProvider.Get<GenericResponse<UserViewModel>>(Urls.GetUserDetail, id).toPromise();
  }

  async deleteUser(Id: string): Promise<GenericResponse<boolean>> {
    return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteUser, Id).toPromise();
  }

  // updateDealer(dealerDetails: DealerViewModel): Promise<GenericResponse<any>> {
  //   return this.dataProvider.Put<GenericResponse<boolean>>(Urls.UpdateDealerDetails, dealerDetails).toPromise();
  // }
  getCreatedByUserList(isCdss){
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCreatedByUser,isCdss).toPromise();
  }


 

}
